import { defineMessages } from 'react-intl';

export default defineMessages({
    defaultOptionTeachers: {
        id: 'sign-in-cards.defaultOptionTeachers',
        defaultMessage: 'All teachers'
    },
    defaultOptionClassrooms: {
        id: 'sign-in-cards.defaultOptionClassrooms',
        defaultMessage: 'All classes'
    }
});



// WEBPACK FOOTER //
// ./app/containers/sign-in-cards/messages.js